import React from 'react';
import { FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const ContactUs = () => {
  return (
    <div className="contactus-wrapper">
      <Helmet>
        <title>Contact Us | Pravisht</title>
        <meta name="description" content="Get in touch with Pravisht. We are here to help with your queries, support, and business needs. Visit our office or contact us via phone or email." />
        <meta name="keywords" content="Contact Pravisht, Get in Touch, Email Pravisht, Call Pravisht, Office Address, Contact Form" />
        <meta name="author" content="Pravisht" />
        <meta property="og:title" content="Contact Us | Pravisht" />
        <meta property="og:description" content="We’d love to hear from you! Reach out to Pravisht via our contact form, phone, or email." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.pravisht.com/contact" />
      </Helmet>
      
    <section>
       <div className="breadcrumb">
              {/* <a href="/">Home</a> &gt; <a href="#">Who We Are</a> &gt; <span>About Us</span> */}
               <a href="/">Home</a> &gt;  <span>Contact Us</span>
           </div>
      <div className="section-header">
        <div className="contact-container">
          <h2>Contact Us</h2>
          <p>
            We’d love to hear from you! Whether you have a question about our solutions, need support, or just want to explore how Pravisht can help your organization—our team is here for you.
          </p>
        </div>
      </div>

      <div className="contact-container">
        <div className="row contact-content">

          <div className="contact-info">
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <i href="#">< FaHome/></i>
              </div>
              <div className="contact-info-content">
                <h4>Address</h4>
                <p>
                  6th Avenue, Gaur City -1, Sec-4,<br />
                  Gr. Noida, UP-201309,<br />
                  India
                </p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">
               <i href="#">< FaPhone/></i>
              </div>
              <div className="contact-info-content">
                <h4>Phone</h4>
                <p>+1 470 666 8431</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">
                 <i href="#">< FaEnvelope/></i>
              </div>
              <div className="contact-info-content">
                <h4>Email</h4>
                <p>Sales@pravisht.com</p>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <form id="contact-form">
              <h2>Send Message</h2>

              <div className="input-box">
                <input type="text" required />
                <span>Full Name</span>
              </div>

              <div className="input-box">
                <input type="email" required />
                <span>Email</span>
              </div>

              <div className="input-box">
                <textarea required></textarea>
                <span>Type your Message...</span>
              </div>

              <div className="input-box">
                <input type="submit" value="Send" />
              </div>
            </form>
          </div>

        </div>
      </div>
    </section>
    </div>
  );
};

export default ContactUs;
